import * as React from "react";
import { TextField } from "@fluentui/react/lib/TextField";
import { Image } from "@fluentui/react/lib/Image";

import { InputProps } from "../../interfaces/props/InputProps";
import { logger } from "../../../../utilities/logger";
import { SharePointMetadataBooleans } from "../../config/sharepointConstants";

export const PictureHyperLink: React.FunctionComponent<InputProps> = ({
  displayName,
  isRequired,
  inputValue,
  updateInputValidationStatus,
  inputValidator,
  error
}: InputProps) => {
  React.useEffect(() => {
    setImageUrl(inputValue?.value);
  }, []);

  const [imageUrl, setImageUrl] = React.useState("");

  const isFirstRun = React.useRef(true);
  React.useEffect(() => {
    try {
      if (isFirstRun.current) {
        isFirstRun.current = false;
        return;
      }
      updateInputValidationStatus(inputValidator.validate(inputValue?.value));
    } catch (e) {
      logger(e, "pictureHyperlink.tsx (useEffect)")
    }
  }, [inputValue?.updatedFromDataSourceToggle]);

  const handleHyperLinkFieldOnchange = (
    event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
    newValue: string
  ): void => {
    updateInputValidationStatus(inputValidator.validate(newValue));
  };

  const onBlurLinkField = React.useCallback((event: any) => {
    setImageUrl(event.target.value);
  }, []);

  const image = imageUrl ? (
    <Image
      src={imageUrl}
      alt="Example with no image fit value and only width is specified."
      width={!error && inputValue ? 250 : 0}
      height={!error && inputValue ? 50 : 0}
      style={{ marginTop: 10 }}
    />
  ) : null;

  const generateTemplate = () => {
    return (
      <>
        <TextField
          onBlur={onBlurLinkField}
          label={displayName}
          disabled={inputValue?.xml?.ReadOnly === SharePointMetadataBooleans.true}
          type="text"
          value={inputValue?.value ?? ""}
          onChange={handleHyperLinkFieldOnchange}
          required={isRequired()}
          errorMessage={error}
          className="xb-sp-input"
        />
        {image}
      </>
    );
  };

  return <>{generateTemplate()}</>;
};

export default PictureHyperLink;
